import linkIcon from './icons/simple_page-link.svg';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

export default class UquendoPageLink extends Plugin {
    init() {
        const editor = this.editor;

		editor.commands.add('insertUquendoPageUrlCommmand',
		{
			execute: async function () {
				await DotNet.invokeMethodAsync('Rvl.KennisPortaal.Client', 'ShowPageModal', editor.dotnet);
			}
		});
        editor.ui.componentFactory.add('insertUquendoPageLink', locale => {
            const button = new ButtonView( locale );

            button.set( {
                id: `btninsertUquendoPageLink_${editor.sourceElement.id}`,
                label: 'Link invoegen van een uQuendo pagina',
                icon: linkIcon,
                tooltip: true,
            } );

			this.listenTo(button, 'execute', () => {
				editor.commands.execute('insertUquendoPageUrlCommmand');
			});

            return button;
        } );
    }
}